// Entra identifiers for the "Ask HR" app registration (infra/entra outputs). Public values:
// every sign-in page shows them. A build can override them with VITE_* variables.

const env = import.meta.env;

export const tenantId: string = env.VITE_TENANT_ID ?? "dc96dfb4-2cfd-4244-8e49-33d252646b03";
export const clientId: string = env.VITE_CLIENT_ID ?? "0c2aa81e-fc25-4707-92c8-786d837285ba";
export const apiScope = `api://${clientId}/access_as_user`;
